<template>
  <div v-if= "marketingJackpotData" class="marketing-jackpot" :class="[{'grid-view': gridView}]" :style="[{
  backgroundImage: `url(${mediaServer(`/static/casino/groups/${group.externalId}/assets/background/${group.externalId}.gif`)})`,
  minHeight: '200px'
}]">
    <div class="group-header">
      <div class="group-logo">
        <img :src="mediaServer(`/static/casino/groups/${group.externalId}/assets/logo/${group.externalId}.svg`)" :alt="jackpotName" class="logo-holder-image">
      </div>
      <div v-if="!gridView" class="see-all"><router-link :to="{ name: 'casino-page', params: { slug: marketingJackpotData.slug }}">{{$t('Casino.See.All')}}</router-link></div>
    </div>
    <div v-if="marketingJackpotData.levels && marketingJackpotData.levels.length > 0" class="marketing-levels-container">
      <div v-for="(level, i) in marketingJackpotLevelsData" :key="i" class="level-wrapper">
        <div v-if="level.name" class="level-item level-name">{{level.name}}</div>
        <div v-if="level.currentValue && level.jackpot" class="level-item level-value"><span v-if="level.currencySymbol" class="currency-symbol">{{level.currencySymbol}}</span> <span class="level-amount">{{level.jackpot.formatedNumber}}</span></div>
        <div v-if="level.startTime || level.endTime" class="level-item level-datetime">
          <span v-if="level.countdown && i === 1" class="countdown">{{level.isStartTime ? $t('Casino.Marketing.Jackpot.Starts.In') : $t('Casino.Marketing.Jackpot.Ends.In')}} {{level.countdown}}</span>
          <span v-if="!level.countdown && level.formatedDate && i === 1" class="formated-date">{{level.isStartTime ? $t('Casino.Marketing.Jackpot.Starts.On') : $t('Casino.Marketing.Jackpot.Ends.On')}} {{level.formatedDate}}</span>
          <span v-if="level.currentValue && i === 0 && level.maxJackpotByCurrency && (level.triggerType && level.triggerType !== 'MBD')" class="jackpot-value">{{$t('Casino.Marketing.Jackpot.Pays.At')}} {{level.currencySymbol}}{{level.maxJackpotByCurrency}}</span>
        </div>
        <div v-if="level.closeToWin && randomMessage" class="level-item level-ctw">{{randomMessage}}</div>
      </div>
    </div>
    <div v-if="marketingJackpotData.groupId" :data-gid="marketingJackpotData.groupId" class="slider-container" :id="'slider-container-' + marketingJackpotData.groupId">
      <casino-slider v-if="groupRender" :section="'marketing-jackpot'" :group="setGroupItems" :gamesByGroup="gamesByGroup"></casino-slider>
      <casino-grid-view v-if="gridView" :data="filterGamesInfoDataByGroup(this.group.gameIds)" :groupData="this.group" :key="componentKey"></casino-grid-view>
    </div>
  </div>
</template>
<script>
import Casino from '@/components/mixins/Casino'
import Url from '@/components/mixins/Url'
import CasinoSlider from '@/components/igaming/partials/casinoSlider.vue'
import CasinoGridView from '@/components/igaming/partials/casinoGridView.vue'
import store from '@/store'
export default {
  name: 'casinoMarketingJackpots',
  components: {
    CasinoSlider,
    CasinoGridView
  },
  props: ['group', 'groupRender', 'groupId', 'gridView'],
  mixins: [
    Casino,
    Url
  ],
  data () {
    return {
      marketingJackpotData: false,
      jackpotName: false,
      isStartTime: false,
      countdown: false,
      currentJackpot: false,
      formatedDate: false,
      currencySymbol: false,
      maxJackpotValue: false,
      componentKey: null
    }
  },
  computed: {
    marketingJackpots () {
      return store.getters['gap/getMarketingJackpots']
    },
    setGroupItems () {
      return this.setGroupSliderItemLimit(this.marketingJackpotData)
    },
    gamesByGroup () {
      return this.filterGamesInfoDataByGroup(this.marketingJackpotData.gameIds)
    },
    randomMessage () {
      return this.setRandomCloseToWinMessage()
    }
  },
  methods: {
    mapJackpotLevels () {
      if (!this.marketingJackpots) return false
      let result = this.marketingJackpots.find(group => group.name === this.jackpotName) || null
      if (result) {
        this.$set(this.marketingJackpotData, 'levels', result.levels)
        this.$set(this.marketingJackpotData, 'currency', result.currency)
      }
      this.initMarketingJackpotLevelsData()
    },
    setRandomCloseToWinMessage () {
      const randomIndex = Math.floor(Math.random() * 6) + 1
      return this.$t('Casino.Close.To.Win.Message.' + randomIndex)
    },
    onJackpotUpdated (levelId, rowNumber) {
      const saved = JSON.parse(localStorage.getItem('mar_jackpots') || '[]')
      const index = saved && saved.findIndex(item => item.levelId === levelId)
      if (index >= 0) {
        saved[index].jackpot = rowNumber
      } else {
        saved.push({ levelId, jackpot: rowNumber })
      }
      localStorage.setItem('mar_jackpots', JSON.stringify(saved))
    }
  },
  mounted () {
    if (this.gridView) this.componentKey = Math.random()
    if (this.group && (this.groupRender || this.gridView)) {
      this.marketingJackpotData = this.group
      this.jackpotName = this.group.groupName
      this.mapJackpotLevels()
    }
    this.startJackpotUpdater()
  },
  watch: {
    marketingJackpots (newVal) {
      if (newVal) this.mapJackpotLevels()
    }
  },
  beforeDestroy () {
    this.stopJackpotUpdater()
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/css/config'
@import '~@/css/mixins'
.marketing-jackpot
  font-family: 'Roboto Condensed Bold'
  min-height 356px
  margin: 60px 0
  &.grid-view
    margin-top 30px
    .group-header
      .group-logo
        .logo-holder-image
          height 120px
          top -35px
          left 10px
          position relative
          @media mobile-big-and-below
            height 85px
    .marketing-levels-container
      margin-top 0
      margin-bottom 10px
      @media mobile-big-and-below
        margin-top -20px
  @media mobile-big-and-below
    margin: 40px 0
  .marketing-levels-container
    display: flex
    margin-left: 35px
    margin-top: 45px
    @media mobile-big-and-below
      flex-wrap: wrap
      margin-top: 30px
      margin-left: 10px
    .level-wrapper
      margin-right: 40px
      @media mobile-big-and-below
        margin-right: 0
        margin-bottom: 10px
      .level-item
        display: block
      .level-name
        font-size: 20px
        font-weight: 700
        margin-bottom: 5px
      .level-value
        padding: 0 40px
        background-color: #13161FE5
        border-radius: 41px
        border: 1px solid #FAA21B
        font-size: 36px
        font-weight: 700
        text-align: center
        line-height: 42px
        margin-bottom: 5px
        @media mobile-big-and-below
          font-size: 26px
          padding: 0 20px
          margin-bottom: 0
        .level-amount
          color: #FFFFFF
      .level-datetime, .level-ctw
        color: #FFFFFF
</style>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoMarketingJackpots.vue